export default __webpack_public_path__ + "static/media/print-first-page.67095d6d.png";